var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement } from 'react';
import styles from './globals.module.scss';
import { useClassNames } from '../../hooks/use-class-names';
export var Flex = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.cfg, cfg = _b === void 0 ? {} : _b, testId = _a.testId, props = __rest(_a, ["className", "children", "cfg", "testId"]);
    var classNames = useClassNames(cfg, [styles.flex, className]);
    return createElement('div', __assign({ className: classNames, 'data-testid': testId }, props), children);
};
export var Section = function (_a) {
    var ariaLabel = _a.ariaLabel, testId = _a.testId, className = _a.className, children = _a.children, _b = _a.cfg, cfg = _b === void 0 ? {} : _b, props = __rest(_a, ["ariaLabel", "testId", "className", "children", "cfg"]);
    var classNames = useClassNames(cfg, [className]);
    return createElement('section', __assign({ className: classNames, 'data-testid': testId, 'aria-label': ariaLabel }, props), children);
};
//# sourceMappingURL=globals.js.map